import axios from "axios";
import React from "react";
import _ from "lodash";
import BallotComponent from "./components/BallotComponent";
import { BallotContext } from "./context/BallotContext";
import BallotInterface from "./interfaces/ballotInterface";
import Router from "./components/Router";
import "./App.scss";
import { BrowserRouter as AppRouter, Routes, Route } from 'react-router-dom';
import VisHelper from './pages/VisHelper';
import Vis2DrillDown from './pages/Vis2DrillDown';
import Dashboard from "./pages/Dashboard";
import PostshowQuestions from "./pages/PostshowQuestions";
import PreshowQuestions from "./pages/PreshowQuestions";
import Thankyou from "./pages/Thankyou";
import Voting from "./pages/Voting";
import Welcome from "./pages/Welcome";
import VisByShow from "./pages/VisByShow";
import WordCloud from "./pages/WordCloud";
import EnhancedWordCloud from "./pages/EnhancedWordCloud";
import EnhancedWordCloudVis from './pages/EnhancedWordCloud';


export default function App() {
  return(
    <div className="container py-4">
    <link rel="preload" href="/fonts/archia-semibold-webfont.woff2" as="font" type="font/woff2" crossOrigin="" />
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap-grid.min.css" />
    <link rel="preload" href="/fonts/archia-medium-webfont.woff2" as="font" type="font/woff2" crossOrigin="" />
    <link rel="preload" href="/fonts/archia-bold-webfont.woff2" as="font" type="font/woff2" crossOrigin="" />    
    <AppRouter>
      <Routes>
      <Route path="/" element={<Welcome />} />
        <Route path="/VisHelper" element={<VisHelper />} />
        <Route path="/drill-down" element={<Vis2DrillDown />} />
        <Route path="/vis-by-show" element={<VisByShow />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/postshowquestions" element={<PostshowQuestions />} />
        <Route path="/preshowquestions" element={<PreshowQuestions />} />
        <Route path="/voting" element={<Voting />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/wordcloud" element={<WordCloud />} />
        <Route path="/enhanced-wordcloud" element={<EnhancedWordCloud />} />
        <Route path="/enhanced-wordcloud-vis" element={<EnhancedWordCloudVis />} />
      </Routes>
    </AppRouter>
    </div>
    );
  }